import { modalController } from '@ionic/core';
import { ProjectDoc } from 'common';

export class CreateProjectController {
  static async present(): Promise<ProjectDoc | null> {
    const modal = await modalController.create({
      component: 'create-project',
      cssClass: 'concourse-modal modal-height-auto',
      backdropDismiss: false,
    });

    return new Promise(resolve => {
      modal.addEventListener('dismiss', () => {
        modal.dismiss();
        resolve(null);
      });
      modal.addEventListener('created', (e: CustomEvent<ProjectDoc>) => {
        modal.dismiss();
        resolve(e.detail);
      });
      modal.present();
    });
  }
}
